// extracted by mini-css-extract-plugin
export default {"container":"Icons_container__bjUWE","img":"Icons_img__O-msJ","group":"Icons_group__FAs73","title":"Icons_title__FMlID","list":"Icons_list__SZTiC","box":"Icons_box__6DeU9"};